export default function getComponentLogicTabId(viewId: number, componentId: string): string {
  return `page:${viewId}:component:${componentId}`;
}
